{
  "zh-TW": {
    "labels": {
      "true": "是",
      "false": "否",
      "null": "-",
      "supporter": {
        "badge": "支持者",
        "tooltip": "本月支持 FleetYards.net"
      },
      "destroyedFleets": {
        "discarded": "已捨棄",
        "purged": "已清除"
      },
      "and": "和",
      "hide": "隱藏",
      "show": "顯示",
      "only": "僅",
      "description": "描述",
      "unavailable": "不可用",
      "selected": "已選擇",
      "actions": "操作",
      "status": "狀態",
      "enabled": "已啟用",
      "disabled": "已禁用",
      "collapse": "摺疊",
      "price": "價格",
      "expand": "展開",
      "distance": "距離",
      "anonymous": "匿名",
      "refreshing": "正在重新載入...",
      "toggleNavigation": "切換導航",
      "openInNewWindow": "全螢幕開啟",
      "or": "或",
      "networkStatusOffline": "網絡狀態：離線 - 服務不可用",
      "groups": "分組",
      "classifications": "分類",
      "features": {
        "stateOn": "已啟用",
        "stateOff": "已停用",
        "stateConditional": "有條件",
        "selfService": "自助服務",
        "actors": "角色",
        "groups": "群組",
        "noGroups": "此功能沒有啟用的群組。",
        "noActors": "此功能沒有啟用的個人角色。",
        "user": "使用者",
        "fleet": "艦隊",
        "actorType": "角色類型",
        "percentageOfActors": "的角色",
        "percentageOfTime": "的時間",
        "currentState": "目前狀態",
        "toggle": "切換",
        "settingsIntro": "為您的帳戶啟用或停用實驗性功能。這些功能可能不完整或隨時變更。",
        "descriptions": {
          "tools_travel_times": "顯示地點之間的預計旅行時間。",
          "tools_cargo_grids": "顯示飛船的互動式貨物網格檢視器。",
          "fleet_starmap": "在艦隊成員頁面顯示 Star Citizen 星圖。"
        },
        "registryHint": "功能旗標宣告於 config/feature_flags.yml，並在部署時建立。你可以在這裡控制它們的開放範圍。",
        "fleetSettingsIntro": "為整個艦隊啟用或停用功能。您在此啟用的內容對所有成員可見。",
        "fleetFeature": "艦隊功能",
        "fleetFeatureInfo": "在此啟用僅對您生效。您艦隊的管理員可為整個艦隊啟用。",
        "toggleForSelf": "僅為自己切換",
        "fleetFeatureGrantedShort": "艦隊已啟用",
        "fleetFeatureGranted": "您的艦隊已為所有成員啟用此功能，因此無法在此處關閉。",
        "groupFeatureGrantedShort": "群組已啟用",
        "groupFeatureGranted": "您所在的某個群組已啟用此功能，因此無法在此處關閉。",
        "groupFeatureGrantedFleet": "該艦隊所在的某個群組已啟用此功能，因此無法在此處關閉。",
        "managedFeatureShort": "受管理",
        "managedFeature": "此功能已為您的帳戶啟用，無法在此處變更。",
        "managedFeatureFleet": "此功能已為該艦隊啟用，無法在此處變更。",
        "selfServiceUser": "使用者可自行切換",
        "selfServiceFleet": "艦隊管理員可切換"
      },
      "oauthApplication": {
        "name": "應用程式名稱",
        "clientId": "客戶端 ID",
        "clientSecret": "客戶端密鑰",
        "redirectUri": "重導向 URI",
        "redirectUriHint": "每行一個 URI。",
        "confidential": "機密",
        "scopes": "權限範圍",
        "scopesHint": "如果未選擇權限範圍，將使用預設範圍: %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "已解決",
        "unresolved": "未解決"
      },
      "imports": {
        "type": "類型",
        "status": "狀態",
        "version": "版本",
        "startedAt": "開始於",
        "finishedAt": "完成於",
        "failedAt": "失敗於",
        "info": "資訊",
        "input": "輸入",
        "output": "輸出",
        "importData": "匯入資料",
        "file": "匯入的檔案",
        "requestedBy": "要求者",
        "adminUser": "管理員使用者",
        "user": "使用者",
        "includeSystem": "包含系統",
        "systemRequester": "系統",
        "statuses": {
          "created": "排隊中",
          "started": "執行中",
          "finished": "已完成",
          "failed": "失敗"
        }
      },
      "oauthApplications": {
        "settingsIntro": "管理您的 OAuth 應用程式。這些應用程式可以代表使用者存取 FleetYards API。",
        "name": "應用程式名稱",
        "redirectUri": "重導向 URI",
        "confidential": "機密",
        "clientId": "客戶端 ID",
        "clientSecret": "客戶端密鑰",
        "scopes": "權限範圍",
        "defaultScopes": "預設權限範圍",
        "confidentialShort": "機密",
        "publicShort": "公開"
      },
      "fleetInviteToken": "艦隊邀請",
      "scDataVersion": "補丁版本",
      "createdAt": "建立於",
      "updatedAt": "更新於",
      "addToHangar": "新增到機庫",
      "home": {
        "search": "搜尋飛船..."
      },
      "shop": {
        "sellPrice": "出售價格",
        "buyPrice": "購買價格"
      },
      "shopCommodity": {
        "item": "項目",
        "shop": "商店",
        "buyPrices": "購買價格",
        "rentalPrices": "租賃價格",
        "confirmed": "已確認？",
        "prices": {
          "label": "價格",
          "sellPrice": "出售價格",
          "buyPrice": "購買價格"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "%{year} 年新飛船",
          "totalShips": "飛船總數",
          "totalMembers": "成員總數",
          "vehicles": "機庫飛船",
          "wishlists": "願望清單飛船",
          "shipOfTheMonth": "月度飛船"
        },
        "modelsByClassification": "按分類劃分的飛船",
        "modelsBySize": "按大小劃分的飛船",
        "vehiclesByModel": "按型號劃分的飛船 (前 %{limit})",
        "modelsPerMonth": "每月飛船數量",
        "modelsByManufacturer": "按製造商劃分的飛船",
        "modelsByProductionStatus": "按生產狀態劃分的飛船",
        "vehiclesPerMonth": "每月機庫飛船",
        "topVehiclesByModel": "前 10 機庫飛船",
        "shipsOfTheMonth": "月度飛船",
        "trendingShips": "瀏覽最多的飛船（30 天）",
        "wishlistByModel": "最受期待的飛船",
        "wishToOwnRatio": "每 100 艘擁有對應的期待數",
        "topPaints": "最受歡迎的塗裝",
        "paintedVehicles": "已塗裝飛船",
        "pledgePriceChanges": "現金購買價變動（12 個月）",
        "mostWishlisted": "本月最受期待的飛船",
        "patchChanges": "本次更新改動最大的飛船",
        "crewDeficit": "船員缺口",
        "crewSurplus": "船員盈餘",
        "membersByRole": "按角色分組成員",
        "csv": {
          "metric": "指標",
          "value": "數值",
          "count": "數量"
        }
      },
      "roadmap": {
        "releases": "發佈",
        "released": "已發佈",
        "lastVersion": {
          "active": {
            "false": "條目已從路線圖移除",
            "true": "條目已重新新增到路線圖",
            "decreased": "項目已從路線圖中移除",
            "increased": "項目已重新添加到路線圖"
          },
          "released": "項目已發佈到 PU",
          "release": "項目從版本 %{old} 移動到 %{new}"
        },
        "stories": {
          "one": "%{count} 個故事",
          "other": "%{count} 個故事"
        },
        "tasks": {
          "one": "%{count} 個任務",
          "other": "%{count} 個任務"
        },
        "ships": {
          "one": "%{count} 艘飛船",
          "other": "%{count} 艘飛船"
        }
      },
      "unknown": "未知",
      "none": "-",
      "notAvailable": "不可用",
      "not-available": "不可用",
      "name": "名稱",
      "homepage": "首頁",
      "discord": "Discord 伺服器",
      "youtube": "YouTube 頻道",
      "twitch": "Twitch 頻道",
      "guilded": "Guilded 伺服器",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "篩選",
      "taxExcluded": "不含稅",
      "hangar": "機庫",
      "public": "公開",
      "hangarStats": "統計",
      "wishlist": "願望清單",
      "fleetchart": "艦隊圖表",
      "fleetchartApp": {
        "screenHeight": "螢幕高度",
        "viewpoint": "視角",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "側面",
          "top": "頂部",
          "angled": "斜角",
          "front": "正面"
        },
        "gridSize": "每格 %{size} 公尺",
        "mode": "模式",
        "modeOptions": {
          "classic": "經典",
          "panzoom": "v2"
        }
      },
      "fleetStats": "統計",
      "hangarMetrics": {
        "total": "總計",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "機庫 aUEC 價值",
        "totalMinCrew": "最少船員",
        "totalMaxCrew": "最多船員",
        "totalCargo": "總貨物",
        "largestShip": "最大飛船",
        "smallestShip": "最小飛船",
        "averagePledgePrice": "平均質押價格",
        "flightReady": "可飛行",
        "uniqueModels": "獨特型號",
        "manufacturerCount": "製造商",
        "missingClassifications": "缺失角色",
        "wishlistTotalMoney": "願望清單質押價值",
        "wishlistTotalCredits": "願望清單遊戲內價值"
      },
      "selectModel": "選擇飛船",
      "findModel": "輸入以查找飛船",
      "find": "輸入以搜尋",
      "selectUser": "選擇使用者",
      "findUser": "輸入以搜尋使用者",
      "selectAdminUser": "選擇管理員使用者",
      "selectFleet": "選擇艦隊",
      "findFleet": "輸入以搜尋艦隊",
      "compare": {
        "removeModel": "移除飛船",
        "addModel": {
          "nullablePrompt": "新增飛船"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "shipCount": {
          "one": "%{count} 艘飛船",
          "other": "%{count} 艘飛船"
        },
        "containersOfSize": "%{size} SCU 貨櫃",
        "armorHp": "裝甲 HP",
        "fuelAndQuantum": "燃料與量子",
        "weaponPoolSize": "武器能量池",
        "crossSection": {
          "x": "截面 X",
          "y": "截面 Y",
          "z": "截面 Z"
        },
        "useAsBaseline": "設為基準",
        "baseline": "基準",
        "differencesOnly": "僅顯示差異",
        "compareToBaseline": "與基準比較",
        "loadoutBySlot": "依掛載槽顯示配置",
        "slots": {
          "guns": "主武器",
          "turrets": "砲塔",
          "missiles": "飛彈",
          "shields": "護盾產生器",
          "powerPlants": "發電機",
          "coolers": "冷卻器",
          "quantumDrives": "量子引擎",
          "thrusters": "主推進器",
          "countermeasures": "反制措施"
        },
        "legend": {
          "best": "本列最佳",
          "worst": "最差",
          "share": "佔本列最佳值的比例",
          "better": "優於基準",
          "worse": "落後基準"
        },
        "selectShips": "選擇飛船"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "賣出",
      "buy": "買入",
      "yourFlagship": "您的旗艦",
      "flagship": "旗艦",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "艦隊",
        "fid": "艦隊 ID",
        "name": "名稱",
        "logo": "標誌",
        "rsiSid": "SID",
        "description": "描述",
        "public": "公開艦隊檢視",
        "publicFleet": "公開艦隊",
        "publicStats": "公開統計",
        "publicFleetStats": "公開艦隊統計",
        "discord": {
          "url": "Discord 伺服器",
          "hint": "連接 Discord 伺服器，即可把活動同步成 Discord 原生的排程活動。成員可以直接在 Discord 上回覆出席，報名資料會同步回 Fleetyards。",
          "guildId": "Discord 伺服器 ID",
          "channelId": "語音頻道 ID（選填）",
          "webhookUrl": "公告 Webhook 網址（選填）",
          "installBotHint": "會在新分頁開啟 Discord 安裝頁面 — 請選擇你要同步活動的伺服器。",
          "statusOk": "已連線至 %{name}",
          "statusCodes": {
            "missing_token": "伺服器端尚未設定 Fleetyards 機器人。請聯絡管理員。",
            "missing_guild": "請先輸入 Discord 伺服器 ID。",
            "invalid_token": "機器人權杖無效。請聯絡管理員。",
            "bot_not_in_guild": "機器人不在這個伺服器裡。請使用安裝連結把它加進去。",
            "guild_not_found": "Discord 無法辨識這個伺服器 ID。請再次確認輸入的值。",
            "discord_error": "Discord 回傳了非預期的錯誤。",
            "request_failed": "無法連線到 Fleetyards。請再試一次。"
          }
        },
        "guilded": "Guilded 伺服器",
        "homepage": "首頁",
        "twitch": "Twitch 頻道",
        "youtube": "Youtube 頻道",
        "backgroundImage": "背景圖片",
        "ts": "Teamspeak 伺服器",
        "awaitingConfirmation": "等待艦隊確認",
        "members": {
          "primary": "主艦隊?",
          "shipsFilter": {
            "label": "哪些飛船應該新增到艦隊?",
            "nullablePrompt": "未選擇選項",
            "field": "飛船選擇",
            "values": {
              "all": "所有飛船",
              "hangar_group": "指定機庫群組中的所有飛船",
              "hide": "無飛船"
            }
          },
          "hangarGroupId": {
            "field": "機庫群組",
            "label": "指定機庫群組",
            "nullablePrompt": "未選擇群組"
          },
          "total": "總計: %{count}",
          "joined": "加入於",
          "invited": "已邀請",
          "invitedAt": "邀請/請求於",
          "requested": "已請求加入",
          "declined": "已拒絕",
          "pending": "待處理的邀請與請求",
          "accepted": "成員",
          "role": "角色",
          "roles": {
            "admin": "管理員",
            "officer": "軍官",
            "member": "成員"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "永久",
          "privilegeGroups": {
            "fleet": "艦隊",
            "memberships": "成員",
            "invites": "邀請",
            "vehicles": "載具",
            "roles": "角色",
            "inventories": "庫存",
            "missions": "任務",
            "events": "活動",
            "notifications": "通知"
          },
          "privileges": {
            "fleet:update": "更新艦隊",
            "fleet:update:images": "更新圖片",
            "fleet:update:description": "更新描述",
            "fleet:delete": "刪除艦隊",
            "fleet:manage": "管理艦隊",
            "fleet:memberships:read": "檢視成員",
            "fleet:memberships:create": "邀請成員",
            "fleet:memberships:update": "更新成員",
            "fleet:memberships:delete": "移除成員",
            "fleet:memberships:manage": "管理成員",
            "fleet:invites:read": "檢視邀請",
            "fleet:invites:create": "建立邀請",
            "fleet:invites:update": "更新邀請",
            "fleet:invites:delete": "刪除邀請",
            "fleet:invites:manage": "管理邀請",
            "fleet:vehicles:read": "檢視載具",
            "fleet:vehicles:create": "新增載具",
            "fleet:vehicles:update": "更新載具",
            "fleet:vehicles:delete": "移除載具",
            "fleet:vehicles:manage": "管理載具",
            "fleet:roles:read": "檢視角色",
            "fleet:roles:create": "建立角色",
            "fleet:roles:update": "更新角色",
            "fleet:roles:delete": "刪除角色",
            "fleet:roles:manage": "管理角色",
            "fleet:inventories:read": "檢視庫存",
            "fleet:inventories:create": "建立庫存",
            "fleet:inventories:update": "更新庫存",
            "fleet:inventories:delete": "刪除庫存",
            "fleet:inventories:manage": "管理庫存",
            "fleet:missions:read": "檢視任務",
            "fleet:missions:create": "建立任務",
            "fleet:missions:update": "更新任務",
            "fleet:missions:delete": "刪除任務",
            "fleet:missions:manage": "管理任務",
            "fleet:events:read": "檢視活動",
            "fleet:events:create": "建立活動",
            "fleet:events:update": "更新活動",
            "fleet:events:delete": "刪除活動",
            "fleet:events:manage": "管理活動",
            "fleet:notifications:manage": "管理通知設定"
          },
          "name": "名稱",
          "rank": "階級"
        },
        "inviteUrls": {
          "noExpiration": "Never expires",
          "used": "已使用 %{count} 次",
          "usedOfLimit": "已使用 %{count} / %{limit}",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 天",
            "7_days": "7 days"
          },
          "limitOptions": {
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses",
            "infinite": "No limit"
          }
        },
        "calendarSubscription": {
          "intro": "產生一個私人連結，讓成員可以在自己的行事曆應用程式（Apple Calendar、Google Calendar、Outlook）中訂閱這個艦隊的活動。",
          "howTo": "把上面的連結分享給你的成員。他們只要把它貼進行事曆應用程式（\"訂閱行事曆\"或\"以網址新增\"）即可。這個連結是私人的 — 任何拿到連結的人都能看到這個艦隊的活動。"
        },
        "notifications": {
          "inAppHint": "選擇哪些活動狀態變化要以應用程式內通知的形式顯示給艦隊成員。",
          "events": {
            "fleet_event": {
              "published": "活動已發布",
              "locked": "報名已鎖定",
              "unlocked": "報名已重新開放",
              "starting_soon": "活動即將開始",
              "started": "活動已開始",
              "completed": "活動已完成",
              "cancelled": "活動已取消",
              "archived": "活動已封存",
              "destroyed": "活動已刪除"
            },
            "fleet_event_signup": {
              "created": "新增報名",
              "withdrawn": "報名已取消"
            }
          }
        },
        "inventories": {
          "name": "名稱",
          "description": "描述",
          "location": "位置",
          "visibility": "可見範圍",
          "manager": "管理人",
          "itemsCount": "記錄數",
          "visibilities": {
            "members_only": "僅限成員",
            "officers_only": "僅限軍官"
          }
        }
      },
      "hangarGroup": {
        "name": "名稱",
        "color": "顏色",
        "sort": "排序",
        "public": "在公開機庫顯示?"
      },
      "source": "來源",
      "loadout": {
        "namePlaceholder": "配置名稱...",
        "urlPlaceholder": "貼上 erkul.games 或 spviewer.eu 的配置網址...",
        "empty": "尚無配置。建立一個開始使用。",
        "active": "使用中",
        "activate": "設為使用中",
        "planOn": "規劃你的配置於"
      },
      "model": {
        "hidden": "隱藏?",
        "active": "活躍?",
        "inGame": "已實裝?",
        "adiMap": "ADI 地圖?",
        "ground": "地面載具?",
        "productionNote": "生產備註",
        "rsiId": "RSI ID",
        "length": "長度",
        "beam": "寬度",
        "height": "高度",
        "scKey": "SC Key",
        "price": "價格",
        "pledgePrice": "質押價格",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "質量",
        "minCrew": "最少船員",
        "maxCrew": "最多船員",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "最大速度",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "貨物",
        "cargoHolds": "貨艙",
        "hydrogenFuelTankSize": "氫燃料箱大小",
        "hydrogenFuelTanks": "氫燃料箱",
        "quantumFuelTankSize": "量子燃料箱大小",
        "quantumFuelTanks": "量子燃料箱",
        "externalFuelTanks": "外掛燃料箱",
        "externalFuelTanksTotal": "總容量",
        "externalFuelTanksCount": "燃料艙",
        "refuelBoom": "加油臂",
        "refuelBoomArm": "支臂",
        "refuelBoomNozzle": "噴嘴",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "偏航（增強）",
        "pitchBoosted": "俯仰（增強）",
        "rollBoosted": "翻滾（增強）",
        "variants": "變體",
        "manufacturer": "製造商",
        "loaners": "借用船",
        "paints": "塗裝",
        "modules": "模組",
        "modulePackages": "模組套件",
        "upgrades": "升級套件",
        "brochure": "手冊",
        "holo": "Holo",
        "angledView": "斜視圖",
        "angledViewColored": "斜視圖（彩色）",
        "sideView": "側視圖",
        "sideViewColored": "側視圖（彩色）",
        "frontView": "前視圖",
        "frontViewColored": "前視圖（彩色）",
        "topView": "俯視圖",
        "topViewColored": "俯視圖（彩色）",
        "onSale": "販售中",
        "playerOwnable": "玩家可擁有?",
        "salesPage": "銷售頁面",
        "addons": "模組與升級套件",
        "storeImage": "商店圖片",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "船員職位",
        "needsCuration": "需要人工校訂",
        "curatedPosition": "手動校訂的位置",
        "baseModel": "基礎型號",
        "fleetchartOffsetLength": "艦隊圖表長度偏移",
        "fleetchartOffsetBeam": "艦隊圖表寬度偏移",
        "extendedLength": "展開長度",
        "extendedBeam": "展開寬度",
        "extendedHeight": "展開高度",
        "extendedFleetchartOffsetLength": "展開艦隊圖表長度偏移",
        "extendedFleetchartOffsetBeam": "展開艦隊圖表寬度偏移",
        "defaultHolo": "預設 Holo",
        "extendedHolo": "展開 Holo",
        "extendedTopView": "展開俯視圖",
        "extendedTopViewColored": "展開俯視圖（彩色）",
        "extendedSideView": "展開側視圖",
        "extendedSideViewColored": "展開側視圖（彩色）",
        "extendedFrontView": "展開前視圖",
        "extendedFrontViewColored": "展開前視圖（彩色）",
        "extendedAngledView": "展開斜視圖",
        "extendedAngledViewColored": "展開斜視圖（彩色）",
        "state": {
          "retracted": "收合",
          "extended": "展開"
        },
        "productionStatus": {
          "in-production": "生產中",
          "in-concept": "概念階段",
          "ready": "機庫就緒",
          "flight-ready": "可飛行",
          "announced": "已公佈"
        },
        "scIdentifier": "SC Identifier"
      },
      "models": {
        "extraColumns": "欄",
        "table": {
          "columns": {
            "storeImage": "圖片",
            "storeImageWide": "寬圖片",
            "rsiStoreImage": "RSI 圖片",
            "rsiStoreImageWide": "寬 RSI 圖片",
            "angledView": "3D 圖片",
            "angledViewWide": "寬 3D 圖片",
            "rsiId": "RSI ID",
            "hidden": "隱藏",
            "active": "活躍",
            "createdAt": "建立於",
            "updatedAt": "更新於",
            "manufacturerName": "製造商",
            "length": "長度",
            "beam": "寬度",
            "height": "高度",
            "mass": "質量",
            "cargo": "貨物",
            "quantumFuelTankSize": "量子燃料",
            "hydrogenFuelTankSize": "氫燃料",
            "minCrew": "船員",
            "maxCrew": "最多船員",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "最大速度",
            "groundMaxSpeed": "地面速度",
            "focus": "定位",
            "productionStatus": "生產狀態",
            "price": "價格",
            "pledgePrice": "質押價格"
          }
        }
      },
      "metrics": {
        "info": "資訊",
        "levels": "等級",
        "views": "檢視",
        "base": "基礎",
        "crew": "船員",
        "speed": "速度",
        "cargo": "貨物",
        "combat": "戰鬥",
        "hardpoints": "掛載點",
        "topView": "Top View"
      },
      "flight": {
        "title": "飛行",
        "scm": "戰鬥巡航",
        "nav": "巡航",
        "boost": "加速",
        "boostSub": "後燃器",
        "reverse": "倒車",
        "maneuverability": "機動性",
        "fuel": "燃料",
        "fuelHydrogen": "氫",
        "fuelQuantum": "量子",
        "hint": "加速後的操控性會隨引擎的電力格提升；引擎沒有供電時全部為零。"
      },
      "base": {
        "price": "價格",
        "priceInGame": "遊戲內",
        "pricePledge": "質押",
        "availability": "供應狀況"
      },
      "availability": {
        "title": "供應狀況",
        "buy": "買入",
        "rent": "租借",
        "cheapest": {
          "buy": "最便宜的購買地點",
          "rent": "最便宜的租借地點"
        },
        "locations": {
          "one": "%{count} 個地點",
          "other": "%{count} 個地點"
        },
        "empty": "沒有已知的購買或租借地點。",
        "timeRange": {
          "1-day": "1 天",
          "3-days": "3 天",
          "7-days": "7 天",
          "30-days": "30 天"
        }
      },
      "cargo": {
        "title": "貨物",
        "holdsSub": "分佈於 %{count} 個貨艙",
        "maxContainerSub": "可容納的最大貨櫃",
        "containers": "貨櫃容量",
        "hint": "各種尺寸的貨櫃在貨物網格上最多可放置的數量；長條顯示它佔總容量的比例。"
      },
      "fuelTanks": {
        "capacitySub": "分佈於 %{count} 個燃料艙",
        "podsSub": "外部掛點",
        "components": "燃料艙類型",
        "perPod": "每個燃料艙",
        "hint": "掛在外部掛載點的燃料艙所攜帶的燃料；長條顯示每種類型佔總容量的比例。"
      },
      "refuelBoom": {
        "fuelFlowSub": "氫燃料輸送",
        "quantumFlowSub": "量子燃料輸送",
        "captureRadiusSub": "對接容許範圍",
        "equipment": "裝備",
        "hint": "加油臂的輸送速率，以及噴嘴的對接容許範圍。"
      },
      "combat": {
        "title": "戰鬥",
        "dps": "爆發 DPS",
        "dpsSub": "%{count} 件武器",
        "sustained": "持續 DPS",
        "sustainedSub": "計入能量回復與熱量",
        "alpha": "Alpha",
        "alphaSub": "每次齊射",
        "weapons": "武器",
        "missileDamage": "飛彈傷害",
        "composition": "傷害組成",
        "damagePhysical": "物理",
        "damageEnergy": "能量",
        "damageDistortion": "扭曲",
        "damageThermal": "熱能",
        "hint": "以預設配置計算的 DPS。持續值會計入每件武器的能量池回復與過熱循環。不含飛彈。"
      },
      "power": {
        "title": "能量分配",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "重設",
        "auto": "自動",
        "aimAssist": "瞄準輔助",
        "cooling": "冷卻",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "點擊以切換軸向（x / y / z）",
        "segmentsUsed": "%{used} / %{total} 段",
        "hint": "在各系統之間分配能量。武器的持續 DPS 會隨分配到的能量提升；其餘部分會自動平衡。",
        "families": {
          "weapon": "武器",
          "shield": "護盾",
          "engine": "引擎",
          "radar": "雷達",
          "coolers": "冷卻器",
          "qdrive": "量子引擎",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "維生系統",
          "miningLaser": "採礦雷射",
          "salvage": "打撈",
          "tractorBeam": "牽引光束",
          "towingbeam": "拖曳光束"
        }
      },
      "defense": {
        "title": "防禦",
        "shieldHp": "護盾 HP",
        "shieldHpSub": "%{count} 具產生器",
        "shieldRegen": "回復",
        "shieldResistances": "抗性",
        "shieldAbsorption": "吸收",
        "armor": "裝甲",
        "deflection": "偏轉",
        "armorReduction": "傷害減免",
        "armorSelfResistance": "自身抗性",
        "armorSignature": "訊號特徵",
        "damageType": {
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "熱能"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "以預設配置計算的護盾與裝甲數值。吸收率低於 100% 表示該傷害類型在護盾還撐著的時候就會打到船體。",
        "openDeflectionCheck": "偏轉檢測"
      },
      "deflectionCheck": {
        "title": "偏轉檢測",
        "intro": "— 哪些武器能貫穿它的防禦？",
        "noArmor": "這艘飛船沒有裝甲，因此不會偏轉任何攻擊。",
        "allSizes": "全部",
        "deflected": "被偏轉",
        "pierce": "貫穿",
        "weapon": "武器",
        "boundary": "偏轉門檻",
        "alpha": "Alpha",
        "threshold": "已跨過門檻",
        "absorbed": "被吸收",
        "versus": "vs",
        "hoverHint": "把滑鼠移到武器上可查看各傷害類型的細項。",
        "note": "Alpha 以每顆彈丸為單位、在護盾吸收之後比較 — 只要在任一種傷害類型上勝過偏轉值，該武器就能貫穿。護盾完全吸收的傷害類型永遠到不了裝甲，因此列為被吸收而非被偏轉：擋下它的是護盾，不是船體。護盾吸收率會依護盾血量在公布的最小至最大範圍之間內插，裝甲偏轉值則隨裝甲血量線性變化。雷射光束不列入計算 — 它造成的是持續傷害，沒有可供比較的單發 Alpha。",
        "margin": "差額",
        "reachesArmor": "打到裝甲",
        "stoppedByShields": "護盾吸收",
        "verdict": {
          "absorbed": "已吸收",
          "deflected": "已偏轉",
          "pierces": "已貫穿"
        },
        "shieldHealth": "護盾血量",
        "armorHealth": "裝甲血量",
        "absorb": "吸收",
        "defl": "偏轉",
        "type": "類型",
        "size": "尺寸"
      },
      "hull": {
        "category": {
          "vital": "要害",
          "secondary": "次要",
          "breakable": "可破壞",
          "subpart": "子部件",
          "cosmetic": "外觀"
        },
        "composition": "船體組成",
        "door": "門",
        "doors": "門",
        "doorsNote": "可破壞的內部艙門屬於獨立區域 — 它們有自己的血量，不計入船體 HP。",
        "doorsSub": "%{count} 個可破壞",
        "hint": "船體 HP 是所有部件血量的總和。",
        "hullHp": "船體 HP",
        "hullHpSub": "所有部件的總和",
        "integrity": "船體完整度",
        "noHp": "無 HP",
        "parts": "船體部件",
        "partsNote": "部件依血量排序；外觀部件（門、梯子、擋板）本身沒有血量。遊戲檔案沒有提供父子關係，因此這是一份平面清單，而不是結構樹。",
        "partsSub": "分佈於 %{count} 個類別",
        "partsTree": "部件 · damageMax",
        "showParts": "顯示船體部件",
        "title": "船體",
        "totalHp": "船體總 HP"
      },
      "manufacturer": {
        "longName": "全名",
        "code": "代碼",
        "logo": "標誌",
        "logoOverridden": "標誌（已覆寫）",
        "icon": "圖示（遊戲檔案）",
        "iconOverridden": "圖示（已覆寫）",
        "scRef": "SC Ref"
      },
      "fundingGoal": {
        "title": "標題",
        "description": "描述",
        "amount": "金額",
        "currency": "幣別",
        "effectiveFrom": "生效日",
        "endedAt": "結束於"
      },
      "supporterContribution": {
        "name": "支持者名稱",
        "user": "已連結帳戶",
        "amount": "金額",
        "currency": "幣別",
        "anonymous": "匿名",
        "recurring": "定期",
        "startedAt": "開始於",
        "endedAt": "結束於",
        "note": "內部備註",
        "stats": {
          "total": "總計",
          "count": "捐助筆數",
          "currentMonth": "本月",
          "currentMonthCount": "%{count} 筆捐助",
          "recurringCount": "定期",
          "anonymousCount": "匿名"
        },
        "chart": {
          "contributions": "捐助",
          "goal": "目標"
        }
      },
      "itemPrice": {
        "price": "價格",
        "location": "位置",
        "locationUrl": "位置 URL"
      },
      "video": {
        "url": "URL",
        "videoType": "類型"
      },
      "modelModule": {
        "name": "名稱",
        "description": "描述",
        "price": "價格",
        "pledgePrice": "承諾價格",
        "productionStatus": "生產狀態",
        "scKey": "SC Key",
        "storeImage": "商店圖片",
        "active": "啟用？",
        "hidden": "隱藏？"
      },
      "dock": {
        "name": "名稱",
        "dockType": "停靠類型",
        "shipSize": "飛船尺寸"
      },
      "modelPosition": {
        "name": "名稱",
        "positionType": "職位類型",
        "source": "來源",
        "position": "排序",
        "types": {
          "pilot": "駕駛",
          "copilot": "副駕駛",
          "turret_gunner": "砲塔射手",
          "engineer": "工程師",
          "gunner": "射手",
          "loadmaster": "裝載長",
          "passenger": "乘客",
          "operator": "操作員",
          "custom": "自訂"
        }
      },
      "modelUpgrade": {
        "name": "名稱",
        "description": "描述",
        "pledgePrice": "質押價格",
        "active": "活躍?",
        "hidden": "隱藏?"
      },
      "modelModulePackage": {
        "name": "名稱",
        "description": "描述",
        "pledgePrice": "質押價格",
        "modules": "模組",
        "active": "活躍?",
        "hidden": "隱藏?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "旋轉 (°)"
      },
      "modelLoaner": {
        "hidden": "隱藏?",
        "loanerModel": "借用型號"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "隱藏?",
        "active": "活躍?",
        "onSale": "販售中",
        "pledgePrice": "質押價格",
        "productionStatus": "生產狀態",
        "productionNote": "生產備註",
        "copyHint": "選擇要把這個塗裝複製過去的目標飛船。複製過程不會修改塗裝資料。",
        "bulkCopyHint": "選擇要把這 %{count} 個塗裝複製過去的目標飛船。複製過程不會修改塗裝資料。",
        "copySameModel": "目標飛船必須與來源飛船不同。"
      },
      "component": {
        "size": "Size: %{size}",
        "grade": "等級",
        "hidden": "隱藏?",
        "componentClass": "組件類別",
        "componentType": "組件類型",
        "componentSubType": "組件子類型",
        "itemType": "物品類型",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "hardpoint": {
        "legend": {
          "headline": "圖例",
          "slotTaken": "插槽已佔用",
          "slotAvailable": "插槽可用"
        },
        "size": "尺寸",
        "rackSize": "架尺寸",
        "details": "詳情",
        "group": "群組",
        "thrusters": {
          "thrust": "推力",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "refuelBoom": {
          "captureRadius": "捕捉半徑",
          "fuelFlowRate": "燃料輸送速率",
          "quantumFuelFlowRate": "量子燃料輸送速率"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "爆發 DPS",
          "sustainedDps": "持續 DPS",
          "efficiency": "效率",
          "penetration": "穿透",
          "fireRate": "射速",
          "speed": "速度",
          "range": "射程",
          "ammo": "彈藥",
          "ammoCost": "彈藥成本",
          "pool": "能量池",
          "maxRegen": "最大回復/秒",
          "costPerShot": "能量/發",
          "heatPerShot": "熱量/發",
          "heatPerSecond": "熱量/秒",
          "chargeTime": "充能時間",
          "fullDamageRange": "全 DMG 距離",
          "zeroDamageRange": "零 DMG 距離",
          "damagePhysical": "物理",
          "damageEnergy": "能量",
          "damageDistortion": "扭曲",
          "damageThermal": "熱能"
        },
        "missiles": {
          "damage": "傷害",
          "speed": "速度",
          "range": "射程",
          "lockRange": "鎖定距離",
          "lockTime": "鎖定時間",
          "trackingSignal": "追蹤"
        },
        "tractorBeams": {
          "maxForce": "最大牽引力",
          "minForce": "最小牽引力",
          "range": "距離",
          "cone": "錐角",
          "tetherBreak": "繫留斷裂",
          "cargoForce": "貨物牽引力",
          "cargoRange": "貨物距離",
          "towForce": "拖曳力",
          "towDistance": "拖曳距離",
          "quantumTowMass": "QT 質量上限",
          "rotationSpeed": "旋轉",
          "moveSpeed": "移動速度"
        },
        "shields": {
          "hp": "HP",
          "regen": "回復",
          "regenTime": "回復時間",
          "downedRegenDelay": "擊潰延遲",
          "damagedRegenDelay": "受損延遲",
          "resistancePhysical": "物理抗性",
          "resistanceEnergy": "能量抗性",
          "resistanceDistortion": "扭曲抗性"
        },
        "coolers": {
          "coolingRate": "冷卻速率"
        },
        "powerPlants": {
          "output": "輸出",
          "pips": "電力格"
        },
        "quantumDrives": {
          "speed": "速度",
          "range": "距離",
          "fuelConsumption": "消耗",
          "spoolUpTime": "預熱",
          "cooldownTime": "冷卻",
          "splineSpeed": "軌道",
          "accel": "加速度"
        },
        "jumpDrives": {
          "fuelEfficiency": "燃料效率",
          "alignRate": "校準速率",
          "tuneRate": "調諧速率",
          "alignDecay": "校準衰減",
          "tuneDecay": "調諧衰減"
        },
        "radar": {
          "aimAssistRange": "輔助範圍",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS"
        },
        "armor": {
          "hp": "HP",
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "熱能",
          "deflectPhysical": "物理偏轉",
          "deflectEnergy": "能量偏轉",
          "selfPhysical": "自身物理抗性",
          "selfEnergy": "自身能量抗性"
        },
        "fuelIntakes": {
          "pushRate": "輸送速率",
          "minRate": "最低速率"
        },
        "sources": {
          "game_files": "遊戲檔案",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "檢視",
          "compact": "精簡",
          "expanded": "展開"
        },
        "fuelTanks": {
          "hydrogen": "氫燃料箱",
          "quantum": "量子燃料箱"
        },
        "jumpDrive": "跳躍引擎",
        "maxContainerSize": "最大貨櫃尺寸",
        "groups": {
          "avionic": "航電",
          "system": "系統",
          "propulsion": "推進",
          "thruster": "推進器",
          "weapon": "武器",
          "defense": "防禦",
          "other": "其他",
          "auxiliary": "輔助",
          "seat": "座位",
          "external_fuel_tank": "外掛燃料箱",
          "refuel_boom": "加油臂"
        },
        "types": {
          "radar": "雷達",
          "computers": "電腦",
          "power_plants": "發電機",
          "coolers": "冷卻器",
          "shield_generators": "護盾產生器",
          "fuel_intakes": "燃料進氣口",
          "fuel_tanks": "燃料箱",
          "quantum_drives": "量子引擎",
          "jump_modules": "跳躍模組",
          "jumpdrive": "跳躍模組",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推進器",
          "maneuvering_thrusters": "機動推進器",
          "weapons": "武器",
          "turrets": "砲塔",
          "missiles": "飛彈",
          "utility_items": "實用設備",
          "utility": "實用設備",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— 選擇模組 —",
        "selectModule": "選擇模組",
        "moduleStock": "出廠狀態",
        "moduleStockHint": "插槽保持船艦出廠時的狀態",
        "categories": {
          "radar": "雷達",
          "armor": "裝甲",
          "relay": "中繼",
          "countermeasures": "反制措施",
          "lifesupport": "生命維持",
          "selfdestruct": "自毀",
          "batteries": "電池",
          "computers": "電腦",
          "powerplant": "發電機",
          "cooler": "冷卻器",
          "module": "模組",
          "shieldgenerator": "護盾產生器",
          "fuel_intakes": "燃料進氣口",
          "fueltanks": "燃料箱",
          "external_fuel_tanks": "外掛燃料箱",
          "refuel_boom": "加油臂",
          "quantumdrive": "量子引擎與跳躍模組",
          "jump_modules": "跳躍模組",
          "jumpdrive": "跳躍模組",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推進器",
          "maneuvering_thrusters": "機動推進器",
          "retro_thrusters": "反推推進器",
          "vtol_thrusters": "VTOL 推進器",
          "weapons": "武器",
          "weapon_mounts": "武器掛載",
          "turret": "砲塔",
          "missiles": "飛彈",
          "missile_racks": "飛彈架",
          "utility_items": "實用設備",
          "utility": "實用設備",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "打撈填充站",
          "cargogrid": "貨物網格",
          "seat": "座位"
        },
        "name": "名稱",
        "category": "分類",
        "source": "來源"
      },
      "blank": {
        "propulsion": "沒有推進系統",
        "modular": "沒有模組",
        "fleetInvites": "沒有邀請"
      },
      "user": {
        "rsiHandle": "使用者名",
        "rsiHandleVerified": "已透過 Citizen iD 驗證",
        "location": "位置",
        "currentSystem": "目前星系",
        "tester": "測試者?",
        "avatar": "頭像",
        "unconfirmedEmail": "未確認的郵件",
        "saleNotify": "我希望收到銷售通知",
        "publicHangar": "公開機庫已啟用",
        "publicHangarLoaners": "在公開機庫顯示借用船提示",
        "publicHangarStats": "公開機庫統計已啟用",
        "publicWishlist": "公開願望清單已啟用",
        "hideOwner": "為艦隊隱藏擁有權",
        "tracking": "允許匿名使用分析",
        "lastActiveAt": "最後活躍",
        "confirmedAt": "確認於",
        "dateFormat": "日期格式",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        }
      },
      "adminUser": {
        "superAdmin": "超級管理員",
        "passwordConfirmation": "確認密碼"
      },
      "vehicle": {
        "name": "名稱",
        "states": "狀態",
        "serial": "序號",
        "owner": "指揮官",
        "flagship": "旗艦",
        "wanted": "想要",
        "loaner": "借用",
        "bundled": "隨附",
        "bundledWith": "隨附於 %{parent}",
        "public": "公開可見",
        "fullPublic": "公開可見（包括名稱）",
        "publicShort": "公開",
        "nameVisible": "公開可見",
        "saleNotify": "我希望收到銷售通知",
        "hangarGroups": "群組",
        "modelPaintSelect": {
          "nullablePrompt": "選擇塗裝",
          "label": "塗裝"
        },
        "bulkGroupEdit": {
          "hint": "現有群組將被覆蓋！"
        },
        "hasLoaners": "借用船",
        "boughtViaSelect": {
          "label": "購買方式"
        }
      },
      "image": {
        "active": "活躍?",
        "background": "用作背景?",
        "caption": "標題",
        "enabled": "已啟用?",
        "file": "圖片檔案",
        "global": "全域?",
        "delete": "刪除",
        "start": "開始",
        "cancel": "取消",
        "processing": "處理中...",
        "error": "錯誤",
        "name": "名稱",
        "size": "檔案大小",
        "dropzone": "將圖片拖放到此處",
        "cancelUpload": "取消上傳",
        "startUpload": "開始上傳",
        "selectImages": "新增圖片...",
        "selectFolder": "新增資料夾..."
      },
      "signup": {
        "link": "還沒有帳戶?",
        "privacyPolicy": "建立 FleetYards 帳戶即表示您同意我們的"
      },
      "privacyPolicy": "隱私政策",
      "login": "使用者名稱或電子郵件",
      "username": "使用者名稱",
      "twoFactorCode": "兩步驟驗證碼",
      "confirmationCode": "確認碼",
      "email": "電子郵件",
      "avatar": "頭像",
      "alreadyRegistered": "已有帳戶?",
      "password": "密碼",
      "passwordConfirmation": "確認密碼",
      "rememberMe": "記住我",
      "emptyList": "沒有 %{name}",
      "all": "全部",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "產生一個私人連結，把你報名的活動加入你個人的行事曆應用程式（Apple Calendar、Google Calendar、Outlook）。",
          "howTo": "把連結貼進你的行事曆應用程式的\"訂閱行事曆\"或\"以網址新增\"中。任何拿到這個連結的人都能看到你報名的活動 — 請妥善保管。"
        }
      },
      "filters": {
        "components": {
          "name": "名稱",
          "itemType": "物品類型",
          "componentClass": "組件類別",
          "buyPriceGt": "購買價格 >=",
          "buyPriceLt": "購買價格 <=",
          "sellPriceGt": "出售價格 >=",
          "sellPriceLt": "出售價格 <=",
          "storeImageBlank": "沒有商店圖片?"
        },
        "shops": {
          "name": "名稱",
          "type": "類型",
          "model": "飛船",
          "equipment": "裝備",
          "component": "組件",
          "commodity": "商品",
          "commodityType": "商品類型"
        },
        "shopCommodities": {
          "commodityType": "商品類型",
          "equipment": "裝備",
          "component": "組件",
          "commodity": "商品",
          "model": "飛船",
          "name": "名稱"
        },
        "shopItems": {
          "category": "分類",
          "subCategory": "子分類",
          "name": "名稱",
          "manufacturer": "製造商"
        },
        "stations": {
          "name": "名稱",
          "type": "太空站類型",
          "shops": "商店",
          "docks": "停靠口"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "價格 <=",
          "priceGt": "價格 >=",
          "wanted": "想要",
          "hidden": "隱藏",
          "public": "公開",
          "group": "群組",
          "loaner": "借用船",
          "bundled": "隨附的 Snub Craft",
          "boughtVia": "購買方式?"
        },
        "tradeRoutes": {
          "sortBy": "Sort by",
          "sortByValues": {
            "percent": "Max. Percent"
          },
          "origin": "From?",
          "destination": "To?"
        },
        "models": {
          "name": "名稱",
          "classification": "分類",
          "focus": "定位",
          "manufacturer": "製造商",
          "onSale": "販售中",
          "size": "尺寸",
          "dockSize": "停靠尺寸",
          "price": "價格",
          "pledgePrice": "質押價格",
          "productionStatus": "生產狀態",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "價格 <=",
          "priceGt": "價格 >=",
          "willItFit": "Will it Fit?",
          "withCargo": "有貨物?",
          "scKeyBlank": "沒有 SC Key?",
          "positionsNeedCuration": "職位需要人工校訂?",
          "fleetchartImageBlank": "沒有艦隊圖表圖片?",
          "holoBlank": "沒有 Holo?",
          "frontViewBlank": "沒有前視圖圖片?",
          "topViewColoredBlank": "沒有彩色俯視圖圖片?",
          "scIdentifierBlank": "沒有 SC 標識?"
        },
        "modelModules": {
          "name": "名稱"
        },
        "manufacturers": {
          "name": "名稱",
          "withModels": "有型號的",
          "logoBlank": "無標誌"
        },
        "supporterContributions": {
          "name": "依名稱搜尋",
          "recurring": "定期",
          "anonymous": "匿名",
          "startedAtGteq": "開始日期從",
          "startedAtLteq": "開始日期至",
          "user": "已連結帳戶",
          "linked": "帳戶連結",
          "linkedOnly": "已連結",
          "unlinkedOnly": "未連結"
        },
        "adminNotifications": {
          "search": "搜尋"
        },
        "images": {
          "model": "飛船"
        },
        "users": {
          "search": "搜尋",
          "username": "使用者名稱",
          "email": "電子郵件",
          "rsiHandle": "RSI 使用者名"
        },
        "fleets": {
          "name": "名稱",
          "fid": "FID",
          "member": "成員",
          "members": {
            "role": "角色",
            "state": "狀態",
            "acceptedAtGt": "Joined from",
            "acceptedAtLt": "Joined until",
            "invitedAtGt": "Invited from",
            "invitedAtLt": "Invited until",
            "requestedAtGt": "Requested from",
            "requestedAtLt": "Requested until",
            "declinedAtGt": "Declined from",
            "declinedAtLt": "Declined until"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "搜尋物品..."
          }
        },
        "manufacturer": "製造商",
        "commodities": {
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "購買價格 >=",
          "buyPriceLt": "購買價格 <=",
          "sellPriceGt": "出售價格 >=",
          "sellPriceLt": "出售價格 <=",
          "storeImageBlank": "沒有商店圖片?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "buyPriceGt": "購買價格 >=",
          "buyPriceLt": "購買價格 <=",
          "sellPriceGt": "出售價格 >=",
          "sellPriceLt": "出售價格 <=",
          "storeImageBlank": "沒有商店圖片?"
        },
        "notifications": {
          "search": "搜尋"
        }
      },
      "station": {
        "docks": "停靠口",
        "location": "位置",
        "type": "類型",
        "shops": "商店",
        "locationPrefix": {
          "default": "on",
          "orbit": "in orbit around"
        }
      },
      "tradeRoutes": {
        "buy": "Buy for: %{uec}",
        "sell": "Sell for: %{uec}"
      },
      "hardpoints": {
        "prefix": "使用以下工具試用配置",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "數據基於以下網站的計算公式"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "選擇飛船"
      },
      "table": {
        "selected": "%{count} 已選擇"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "價格",
        "type": "類型",
        "shop": "商店"
      },
      "syncExtension": {
        "warnings": "警告",
        "status": {
          "started": "匯入已開始...",
          "finished": "匯入完成",
          "failed": "匯入失敗!"
        },
        "processSteps": {
          "fetchHangar": "正在從 RSI 機庫取得資料",
          "submitData": "正在提交資料到 Fleetyards.net 後台"
        },
        "sessionStatus": "RSI 工作階段狀態",
        "checkIdentity": "檢查 RSI 工作階段",
        "identityStatus": {
          "pending": "檢查中...",
          "notFound": "未找到",
          "connected": "已連接"
        },
        "platforms": {
          "chrome": "Google Chrome or Chromium based Browsers",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "頁面",
          "all": "所有質押物品",
          "ships": "飛船",
          "components": "模組",
          "upgrades": "升級"
        },
        "importedItems": {
          "importedVehicles": "已新增飛船",
          "foundVehicles": "找到的飛船",
          "movedVehiclesToWanted": "飛船已移至願望清單",
          "missingModels": "未找到飛船",
          "importedComponents": "已新增組件",
          "foundComponents": "找到的組件",
          "missingComponents": "未找到組件",
          "missingComponentVehicles": "未找到匹配的飛船用於組件",
          "importedUpgrades": "已新增升級",
          "foundUpgrades": "找到的升級",
          "missingUpgrades": "未找到升級",
          "missingUpgradeVehicles": "未找到匹配的飛船用於升級"
        }
      },
      "cargoGridViewer": {
        "capacity": "容量",
        "maxContainerSize": "最大貨櫃",
        "packed": "已裝載",
        "totalCargo": "總貨物",
        "didNotFit": "放不下",
        "enoughShips": "四艘飛船已填滿網格。",
        "addShip": "新增飛船",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "量子引擎",
        "fuelUsage": "燃料消耗",
        "travelTime": "旅行時間",
        "poweredBy": "基於",
        "rank": "#",
        "size": "尺寸",
        "grade": "等級",
        "sizeValue": "S%{size}",
        "intro": "每台量子引擎完成這次躍遷需要多久——以及消耗多少量子燃料。",
        "jumpDistance": "躍遷距離",
        "distanceHint": "1 Mkm 即一百萬公里。橫越斯坦頓約需 40。",
        "filters": "篩選",
        "resetFilters": "重設",
        "barLegend": "長條表示相對最慢引擎的時間",
        "count": "%{count} 台引擎",
        "countFiltered": "%{total} 台中的 %{count} 台",
        "noMatch": "沒有引擎符合這些篩選條件。",
        "presets": {
          "moon": "月球距離",
          "short": "短距躍遷",
          "system": "橫越斯坦頓",
          "far": "長途"
        }
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "線上使用者",
            "totalUsers": "總使用者數",
            "totalShips": "總飛船數",
            "newShipsInYear": "%{year} 新飛船",
            "totalFleets": "總艦隊數"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "manual": "手動"
          }
        },
        "resourceAccess": {
          "title": "資源存取權",
          "groups": {
            "ship_data": "飛船資料",
            "community": "社群",
            "system": "系統"
          },
          "privileges": {
            "models": "型號",
            "model_modules": "型號模組",
            "components": "組件",
            "manufacturers": "製造商",
            "vehicles": "載具",
            "images": "圖片",
            "fleets": "艦隊",
            "users": "使用者",
            "supporters": "支持者",
            "admins": "管理員",
            "oauth_applications": "OAuth 應用程式",
            "maintenance": "維護",
            "imports": "匯入",
            "features": "功能",
            "workers": "背景工作",
            "pghero": "PgHero",
            "rsi-api-status": "RSI API 狀態",
            "stats": "統計"
          }
        },
        "versions": {
          "blank": "空白",
          "revertQuestion": "要還原嗎？",
          "sources": {
            "custom": "管理員",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "遊戲檔案",
            "sc_loader": "遊戲檔案",
            "uex_price_sync": "UEX 價格同步",
            "unknown": "未知"
          }
        },
        "models": {
          "unlisted": "未收錄"
        }
      },
      "hangarTable": {
        "extraColumns": "欄",
        "columns": {
          "storeImage": "圖片",
          "storeImageWide": "寬圖片",
          "angledView": "3D 圖片",
          "angledViewWide": "寬 3D 圖片",
          "modelManufacturerName": "製造商",
          "modelLength": "長度",
          "modelBeam": "寬度",
          "modelHeight": "高度",
          "modelMass": "質量",
          "modelCargo": "貨物",
          "modelMinCrew": "船員",
          "modelMaxCrew": "最多船員",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelFocus": "定位",
          "modelProductionStatus": "生產狀態",
          "modelPrice": "價格",
          "modelPledgePrice": "質押價格"
        }
      },
      "fleetTable": {
        "extraColumns": "欄",
        "columns": {
          "storeImage": "圖片",
          "storeImageWide": "寬圖片",
          "angledView": "3D 圖片",
          "angledViewWide": "寬 3D 圖片",
          "modelManufacturerName": "製造商",
          "modelLength": "長度",
          "modelBeam": "寬度",
          "modelHeight": "高度",
          "modelMass": "質量",
          "modelCargo": "貨物",
          "modelMinCrew": "船員",
          "modelMaxCrew": "最多船員",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelProductionStatus": "生產狀態",
          "modelPrice": "價格",
          "modelPledgePrice": "質押價格",
          "owner": "擁有者"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "超出貨艙容量",
        "cargoGrid": "貨艙網格",
        "shipInventory": "飛船庫存",
        "remaining": "剩餘",
        "unmeasured": "%{count} 項尚未測量"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "收件匣",
        "archive": "封存",
        "unreadOnly": "僅未讀",
        "status": "狀態",
        "severity": "嚴重程度",
        "type": "類型",
        "selectPrompt": "選擇一則通知來閱讀",
        "noBody": "這則通知沒有更多細節。",
        "lastSeen": "最後出現",
        "expires": "到期",
        "severities": {
          "info": "資訊",
          "warning": "警告",
          "error": "錯誤"
        },
        "types": {
          "paints_import": "塗裝匯入",
          "modules_import": "模組匯入",
          "loaner_sync": "借用船同步",
          "uex_prices_import": "UEX 價格同步",
          "uex_commodity_prices_import": "UEX 商品同步",
          "new_supporter": "新支持者",
          "rsi_api_blocked": "RSI API 已封鎖",
          "rsi_api_unblocked": "RSI API 已恢復",
          "weekly_stats": "每週報告",
          "ship_matrix_import": "Ship Matrix 匯入",
          "sc_data_import": "sc_data 匯入",
          "import_run": "匯入"
        }
      },
      "optional": "選填",
      "notificationActions": {
        "open": "開啟",
        "openHangar": "開啟機庫",
        "openWishlist": "開啟願望清單",
        "openModel": "顯示飛船",
        "openInvite": "檢視邀請",
        "reviewRequest": "審核申請",
        "openMembers": "顯示成員",
        "openFleet": "開啟艦隊",
        "openInventory": "開啟庫存",
        "openEvent": "開啟活動",
        "openRoster": "顯示報名名單",
        "addToCalendar": "加入行事曆",
        "openStore": "質押商店",
        "accept": "接受",
        "decline": "拒絕",
        "signUp": "報名",
        "withdraw": "取消報名",
        "syncAgain": "再次同步",
        "markAsBought": "標示為已購買",
        "unavailable": "這項內容已無法使用。"
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "郵件",
          "push": "推播",
          "discord": "Discord"
        },
        "groups": {
          "account": "帳戶與機庫",
          "fleetMembership": "艦隊成員資格",
          "fleetEvents": "艦隊活動"
        },
        "hangar_create": "機庫已建立",
        "hangar_destroy": "機庫已移除",
        "hangar_sync_finished": "機庫同步完成",
        "hangar_sync_failed": "機庫同步失敗",
        "wishlist_create": "已加入願望清單",
        "wishlist_destroy": "已從願望清單移除",
        "model_on_sale": "型號特價中",
        "new_model": "新型號發布",
        "fleet_invite": "收到艦隊邀請",
        "fleet_member_requested": "已申請加入",
        "fleet_member_accepted": "會員資格已接受",
        "fleet_request_accepted": "加入申請已通過",
        "fleet_inventory_item_added": "艦隊庫存已新增物品",
        "fleet_event_published": "活動已發布",
        "fleet_event_locked": "活動報名已鎖定",
        "fleet_event_starting_soon": "活動即將開始",
        "fleet_event_started": "活動已開始",
        "fleet_event_completed": "活動已完成",
        "fleet_event_cancelled": "活動已取消",
        "fleet_event_signup_added": "新報名",
        "fleet_event_signup_withdrawn": "報名已取消",
        "fleet_event_signup_confirmed": "報名已確認",
        "fleet_event_signup_assigned": "已指派席位",
        "fleet_event_signup_kicked": "已從席位移除",
        "allInGroup": "這個群組的全部項目"
      },
      "fleets": {
        "missions": {
          "title": "標題",
          "description": "描述",
          "team": "隊伍",
          "teams": "隊伍",
          "ship": "飛船",
          "ships": "飛船",
          "slot": "席位",
          "slots": "席位",
          "noMissions": "尚無任務。",
          "noTeams": "尚未新增任何隊伍。",
          "noShips": "尚未新增任何飛船。",
          "noSlots": "尚未新增任何席位。",
          "archivedTab": "已封存",
          "activeTab": "進行中",
          "archived": "已封存",
          "modelSpecific": "指定飛船",
          "modelList": "任選其一",
          "modelListHint": "這個位置由你挑選的任一艘飛船擔任皆可。",
          "allowedShips": "符合條件的飛船",
          "anyOf": "任一",
          "filterRange": "篩選範圍",
          "classification": "分類",
          "focus": "定位",
          "minSize": "最小尺寸",
          "maxSize": "最大尺寸",
          "minCrew": "最少船員",
          "minCrewOverride": "覆寫",
          "minCrewOverrideLabel": "最少船員覆寫",
          "minCrewOverrideHint": "留空即使用飛船預設的最少船員數。",
          "minCargo": "最少貨物（SCU）",
          "createdBy": "建立者",
          "seats": "座位",
          "category": "分類",
          "coverImage": "封面圖片",
          "coverPresets": "從範例中挑選",
          "scenario": "情境",
          "categories": {
            "other": "其他",
            "ship_combat": "艦船戰鬥",
            "ground_combat": "地面戰鬥",
            "combined_combat": "聯合作戰",
            "mining": "採礦",
            "salvage": "打撈",
            "cargo_hauling": "貨運",
            "exploration": "探索"
          }
        },
        "events": {
          "title": "標題",
          "description": "描述",
          "briefing": "簡報",
          "startsAt": "開始時間",
          "endsAt": "結束時間",
          "timezone": "時區",
          "location": "活動地點",
          "meetupLocation": "集合地點",
          "visibility": "可見範圍",
          "maxAttendees": "人數上限",
          "autoLockEnabled": "自動鎖定報名",
          "autoLockMinutesBefore": "開始前幾分鐘鎖定",
          "recurring": "重複",
          "recurringHint": "依重複排程自動產生這個活動。成員需要針對每一場分別報名。",
          "recurringSummary": "重複頻率：%{interval}",
          "recurringUntil": "重複頻率：%{interval}，直到 %{date}",
          "recurringForCount": "重複頻率：%{interval}（共 %{count} 場）",
          "viewSeries": "檢視系列",
          "recurrenceInterval": "重複間隔",
          "recurrenceEnd": "結束",
          "recurrenceEndNever": "永不",
          "recurrenceEndOn": "在指定日期",
          "recurrenceEndAfter": "經過",
          "recurrenceEndOccurrences": "場",
          "recurrence": {
            "daily": "每天",
            "weekly": "每週",
            "biweekly": "每兩週",
            "monthly": "每月"
          },
          "occurrencesSection": "即將到來的場次",
          "skipOccurrence": "略過這一場",
          "overrideOccurrence": "覆寫 %{date} 的場次",
          "overrideOccurrenceShort": "編輯這一場",
          "overrideOccurrenceHint": "只為這一場覆寫欄位。留空則沿用重複活動的設定。",
          "endSeriesHere": "從這裡起停止",
          "excludedBadge": "已略過",
          "noUpcomingOccurrences": "未來 12 週內沒有即將到來的場次。",
          "endSeriesConfirm": "要在這個日期之後停止重複嗎？之後的場次將不會再產生。",
          "skipOccurrenceSuccess": "已略過這一場。",
          "endSeriesSuccess": "系列已從這個日期起結束。",
          "cancelledReason": "取消原因",
          "createdBy": "建立者",
          "signups": "報名",
          "signupsCount": "%{count} 筆報名",
          "youAreHere": "你在這裡",
          "attendance": "出席",
          "signupsLockedHint": "這個活動的報名已鎖定。",
          "alreadySignedUpHint": "你已經報名了另一個席位。要更換的話請先取消報名。",
          "slotTakenHint": "這個席位已經有人了。",
          "currentSlot": "目前席位",
          "currentSlotHint": "這是該筆報名目前所在的席位。",
          "takenBy": "已由 %{username} 佔用",
          "slotPickerHint": "為這筆報名挑選一個席位。已被佔用或無法使用的席位會停用。",
          "signupCtaHint": "報名參加這個活動 — 你可以現在挑選特定席位，或稍後讓管理員為你指派。",
          "noSlotYet": "尚未指派席位",
          "signupApproval": "報名審核",
          "signupStatuses": {
            "confirmed": "已確認",
            "tentative": "暫定",
            "interested": "有興趣",
            "pending": "等待審核",
            "withdrawn": "已取消報名"
          },
          "signupApprovals": {
            "direct": "直接加入",
            "confirmation_required": "需要確認"
          },
          "unassignedSignupsHint": "這些成員已經報名活動，但還沒有席位。請在下方為他們指派，或移除該筆報名。",
          "taken": "已佔用",
          "grantedRoles": "已授予的角色",
          "noEventAdminsYet": "尚無其他管理員或版主。",
          "creator": "活動建立者",
          "eventTeamHint": "授予其他成員這個活動的管理員或版主權限。管理員可以編輯活動，版主可以管理報名。",
          "eventRole": "角色",
          "eventRoles": {
            "admin": "管理員",
            "moderator": "版主"
          },
          "memberPicker": "成員",
          "spawnedEvents": "已產生的活動",
          "fromMission": "來自任務",
          "pickTemplate": "挑選範本",
          "pickTemplateHint": "可以選擇以任務範本為起點 — 欄位會預先填好，活動也會連結回該任務。",
          "noTemplate": "不使用範本",
          "noTemplateHint": "從空白開始建立活動。",
          "changeTemplate": "更換範本",
          "clearTemplate": "清除範本",
          "myVehicle": "我的載具",
          "selectVehicle": "選擇載具（選填）",
          "vehicleMismatchHint": "所選載具不符合這個席位的需求。",
          "noFittingInHangar": "你的機庫裡沒有符合這個席位的載具。你仍然可以不選載具直接報名。",
          "vehicleFitsHint": "會帶一艘符合這艘飛船的載具。",
          "noMatchingVehicle": "沒有任何報名帶來符合的載具。",
          "shipNotCrewedYet": "尚無符合的報名。",
          "expandHint": "%{model} 還有 %{count} 個座位。要新增席位讓其他人填補嗎？",
          "notes": "備註",
          "upcomingTab": "即將舉行",
          "pastTab": "過去",
          "archivedTab": "已封存",
          "listTab": "清單",
          "calendarTab": "行事曆",
          "subscribeHint": "把行事曆訂閱網址複製到剪貼簿，方便你貼進行事曆應用程式。",
          "visibilities": {
            "members": "成員",
            "officers": "幹部",
            "fleet": "公開"
          },
          "statuses": {
            "draft": "草稿",
            "open": "開放報名",
            "locked": "報名已鎖定",
            "active": "進行中",
            "completed": "已完成",
            "cancelled": "已取消",
            "past": "已結束"
          },
          "tabs": {
            "basic": "基本資訊",
            "description": "描述與封面",
            "teams": "隊伍與飛船",
            "overview": "總覽",
            "settings": "設定"
          },
          "calendar": {
            "month": "月",
            "week": "週",
            "weekTitle": "%{date} 當週"
          },
          "repeats": "重複"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "notifications": {
        "inbox": "收件匣",
        "archive": "封存",
        "unreadOnly": "僅未讀",
        "status": "狀態",
        "type": "類型",
        "selectPrompt": "選擇一則通知來閱讀",
        "noBody": "這則通知沒有更多細節。",
        "archivesOn": "移至封存",
        "deletesOn": "刪除於"
      },
      "unlistedModel": {
        "linkHint": "%{identifier} 對應目錄中的哪艘飛船？建議來自匯出資料，可能有誤。"
      },
      "slug": "Slug",
      "inventories": {
        "source": "來源",
        "sources": {
          "vehicle": "飛船",
          "handMade": "手動建立"
        }
      },
      "inventoryItems": {
        "name": "名稱",
        "category": "分類",
        "entryType": "異動",
        "quantity": "數量",
        "quality": "品質",
        "notes": "備註",
        "itemType": "目錄",
        "categories": {
          "commodity": "商品",
          "component": "組件",
          "weapon": "武器",
          "equipment": "裝備",
          "ammunition": "彈藥",
          "consumable": "消耗品",
          "other": "其他"
        },
        "entryTypes": {
          "deposit": "存入",
          "withdrawal": "取出"
        },
        "units": {
          "scu": "SCU",
          "units": "個"
        }
      },
      "scDataSource": {
        "dataSource": "資料來源",
        "notLive": "不是 live 版本"
      },
      "erkul": {
        "prefix": "Tryout Loadouts with",
        "link": "Erkul's DPS Calculator"
      },
      "shipHistory": {
        "sales": "促銷歷史",
        "salesCount": "記錄的促銷",
        "lastSale": "最近一次促銷",
        "averageGap": "平均間隔",
        "days": "%{count} 天",
        "ongoing": "進行中",
        "priceHistory": "現金購買價歷史",
        "firstPriced": "首次定價",
        "priceRemoved": "價格已移除",
        "wishlist": "每月願望清單新增",
        "patchChanges": "更新改動",
        "notRecordedYet": "僅從開始記錄之日起統計，因此飛船可能尚無記錄。"
      },
      "buildCompare": {
        "from": "起始版本",
        "to": "目標版本",
        "appeared": "新增",
        "vanished": "移除",
        "changed": "變更",
        "notRecorded": "其中一個版本沒有記錄該目錄。",
        "needsTwoBuilds": "只記錄了一個版本，無法進行比較。",
        "pickTwoBuilds": "請選擇兩個不同的版本。",
        "failed": "無法比較這兩個版本。",
        "andMore": "還有 %{count} 項",
        "catalogues": {
          "components": "部件",
          "equipment": "裝備",
          "commodities": "商品",
          "models": "艦船"
        }
      }
    }
  }
}
